var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhysics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.998,
    height: 40,
    viewBox: "0 0 39.998 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "physics",
    transform: "translate(-0.002 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91311",
    "data-name": "Path 91311",
    d: "M37.607,2.393C33.65-1.564,27.741-.6,20,5.227,12.261-.6,6.354-1.565,2.394,2.393S-.6,12.259,5.227,20C-.6,27.739-1.565,33.648,2.394,37.607A7.834,7.834,0,0,0,8.131,40c3.285,0,7.252-1.754,11.87-5.227C24.616,38.249,28.583,40,31.87,40a7.834,7.834,0,0,0,5.737-2.4c3.959-3.959,3-9.866-2.834-17.607C40.6,12.259,41.566,6.352,37.607,2.393Zm-5.8.985a4.677,4.677,0,0,1,3.445,1.365c2.91,2.912.76,7.856-2.647,12.566-1.4-1.647-2.97-3.359-4.764-5.154s-3.51-3.369-5.157-4.767C25.851,5.1,29.121,3.378,31.81,3.378ZM30.52,20c-1.685,2.034-3.47,3.935-5.027,5.5S22.034,28.834,20,30.52c-2.034-1.685-3.935-3.47-5.492-5.019S11.166,22.034,9.481,20c1.685-2.034,3.47-3.937,5.027-5.492S17.967,11.166,20,9.479c2.034,1.684,3.935,3.472,5.5,5.029S28.835,17.967,30.52,20ZM4.746,4.745A4.667,4.667,0,0,1,8.191,3.378c2.689,0,5.959,1.722,9.123,4.01-1.647,1.4-3.36,2.972-5.157,4.767s-3.367,3.5-4.765,5.154C3.986,12.6,1.832,7.656,4.746,4.745Zm0,30.5c-2.91-2.91-.76-7.856,2.645-12.565,1.4,1.647,2.972,3.359,4.765,5.154s3.5,3.372,5.149,4.769c-4.709,3.41-9.653,5.562-12.56,2.649Zm30.5,0c-2.909,2.907-7.851.762-12.56-2.642,1.643-1.4,3.357-2.979,5.149-4.769s3.367-3.5,4.764-5.154c3.414,4.717,5.567,9.661,2.654,12.571Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3046",
    "data-name": "Ellipse 3046",
    cx: 3.334,
    cy: 3.334,
    r: 3.334,
    transform: "translate(16.667 16.666)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysics);
export default __webpack_public_path__ + "static/media/physics.ade9fc59a8e01c171f942c445fc6dbb3.svg";
export { ForwardRef as ReactComponent };